import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { SpaceStateFilterValues } from 'src/features/spaces/constants/space-state/space-state-filter-values';
import { SpaceState } from 'src/features/spaces/types/space-state';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const SpaceStateFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation(['spaces']);

  const filterGroup: FilterGroup<(typeof SpaceStateFilterValues)[SpaceState]> =
    {
      id: 1,
      type: 'state',
      label: t('spaces:common.state.title'),
      singleOption: true,
      filterOperator: 'custom',
      items: [
        {
          label: t('spaces:common.state.available'),
          value: SpaceStateFilterValues.AVAILABLE,
        },
        {
          label: t('spaces:common.state.unavailable'),
          value: SpaceStateFilterValues.BLOCKED,
        },
        {
          label: t('spaces:common.state.booked'),
          value: SpaceStateFilterValues.BOOKED,
        },
      ],
    };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={(filters[filterGroup.type]?.value as string[]) ?? []}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items}
    />
  );
};
